<template>
    <div class="sip-row-actions sip-row-actions--icons" data-sip-vue="1" :class="{ 'is-open': open }">
        <button
            v-if="canView"
            type="button"
            class="sip-row-actions__icon-btn"
            :aria-label="trans('general.view')"
            @click.prevent="onView"
        >
            <admin-icon name="file-search" :size="16" class="sip-row-actions__glyph"></admin-icon>
            <span class="sip-row-actions__btn-label">{{ trans('general.view') }}</span>
        </button>
        <button
            v-if="canEdit"
            type="button"
            class="sip-row-actions__icon-btn"
            :aria-label="trans('general.edit')"
            @click.prevent="onEdit"
        >
            <admin-icon name="pencil" :size="16" class="sip-row-actions__glyph"></admin-icon>
            <span class="sip-row-actions__btn-label">{{ trans('general.edit') }}</span>
        </button>
        <button
            v-if="canDelete && deleteConfirm"
            type="button"
            class="sip-row-actions__icon-btn is-danger"
            :aria-label="trans('general.delete')"
            :key="deleteKey || 'delete'"
            v-confirm="deleteConfirm"
        >
            <admin-icon name="trash" :size="16" class="sip-row-actions__glyph"></admin-icon>
            <span class="sip-row-actions__btn-label">{{ trans('general.delete') }}</span>
        </button>
        <button
            v-else-if="canDelete"
            type="button"
            class="sip-row-actions__icon-btn is-danger"
            :aria-label="trans('general.delete')"
            @click.prevent="onDelete"
        >
            <admin-icon name="trash" :size="16" class="sip-row-actions__glyph"></admin-icon>
            <span class="sip-row-actions__btn-label">{{ trans('general.delete') }}</span>
        </button>
        <div v-if="hasOverflow" class="sip-row-actions__more">
            <button
                :id="triggerId"
                type="button"
                class="sip-row-actions__icon-btn sip-row-actions__more-btn"
                :aria-label="moreLabel"
                aria-haspopup="menu"
                :aria-expanded="open ? 'true' : 'false'"
                ref="toggle"
                @click.stop.prevent="onToggle"
            >
                <admin-icon name="more-horizontal" :size="16" class="sip-row-actions__glyph"></admin-icon>
                <span class="sip-row-actions__btn-label">{{ moreLabel }}</span>
            </button>
            <div
                class="sip-row-actions__menu"
                :class="{ 'is-open': open }"
                role="menu"
                :aria-labelledby="triggerId"
                ref="menu"
                @click.capture="onMenuClick"
            >
                <slot name="before"></slot>
                <slot></slot>
                <slot name="after"></slot>
            </div>
        </div>
    </div>
</template>

<script>
import { toggleRowActionMenu, closeRowActionMenu } from '../directives/row-actions'

let seq = 0

export default {
    name: 'row-actions-dropdown',
    props: {
        canView: { type: Boolean, default: true },
        canEdit: { type: Boolean, default: true },
        canDelete: { type: Boolean, default: true },
        deleteConfirm: { type: [Object, Function], default: null },
        deleteKey: { default: null }
    },
    data() {
        return {
            triggerId: 'sip-ra-vue-' + (++seq),
            open: false
        }
    },
    computed: {
        hasOverflow() {
            return !!(this.$slots.before || this.$slots.default || this.$slots.after);
        },
        moreLabel() {
            return this.trans('general.more') || 'More';
        }
    },
    beforeDestroy() {
        closeRowActionMenu()
    },
    methods: {
        onToggle() {
            toggleRowActionMenu(this.$refs.toggle, this.$refs.menu)
            this.$nextTick(this.syncOpen)
        },
        syncOpen() {
            this.open = !!(this.$refs.menu && this.$refs.menu.classList.contains('is-open'))
        },
        onMenuClick() {
            this.$nextTick(function () {
                closeRowActionMenu()
                this.open = false
            }.bind(this))
        },
        onView() {
            closeRowActionMenu()
            this.open = false
            this.$emit('view')
        },
        onEdit() {
            closeRowActionMenu()
            this.open = false
            this.$emit('edit')
        },
        onDelete() {
            closeRowActionMenu()
            this.open = false
            this.$emit('delete')
        }
    }
}
</script>
